<mat-spinner [diameter]="config.diameter"
    [strokeWidth]="config.strokeWidth" />
